import React, { useMemo } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import isFunction from 'lodash/isFunction';
import { Badge, Card } from 'react-bootstrap';

// HELPERS
import { useListData } from 'helpers/getListData';

// LOCAL COMPONENTS
import ActionsCell from '../../tools/ActionsCell';
import ListCardToggle from '../parts/ListCardToggle';

// STYLES
import styles from './listCardHeader.module.scss';

// LOCAL VARIABLES
import { PLACEHOLDER } from '../../variables';

const ListCardHeader = ({
  index, //
  placeholder = PLACEHOLDER,
  previewKeys = [],
  resizeRow,
  row,
  ...props
}) => {
  // LIST CONTEXT
  const {
    actions, //
    columns = []
  } = {...(useListData() || {}), ...props};

  // TODO: Filter out hidden?
  // MEMOS
  const headerColumns = useMemo(() => {
    return previewKeys.reduce((arr, field) => {
      const match = columns.find(c => c.key === field);
      if (match) arr.push(match);
      return arr;
    }, []);
  }, [columns, previewKeys]);

  return (
    <Card.Header className="d-flex align-items-center px-3 py-2 border-0">
      <div className="d-flex align-items-start flex-grow-1">
        <div className={styles.badgeCol}>
          <Badge className={clsx(styles.badge, 'p-2 me-3 bg-primary text-gray-600')}>{index + 1}</Badge>
        </div>
        <div className="flex-grow-1">
          {headerColumns.map((c, j) => {
            return (
              <div key={j} className="d-flex flex-wrap align-items-center my-2">
                <div className={clsx(styles.label, 'text-gray-600 me-3')}>{c.mobileLabel || c.label}:</div>
                <div className={c.className}>
                  {isFunction(c.component)
                    ? c.component({
                        value: row[c.key], //
                        column: c,
                        row: { original: row },
                        placeholder
                      })
                    : ![undefined, null, ''].includes(row[c.key])
                    ? row[c.key]
                    : placeholder}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="d-flex ps-2">
        {actions?.length ? <ActionsCell actions={actions} record={row} /> : null}
        <ListCardToggle eventKey="0" onToggle={resizeRow} />
      </div>
    </Card.Header>
  );
};

// EXPORT
export default ListCardHeader;
